import { defineComponent as _defineComponent } from 'vue'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredLabel',
  props: {
    tooltipPosition: { default: 'down-right' }
  },
  setup(__props: any) {



return { __sfc: true,faInfoCircle }
}

})